import React from "react";

const GetInfo: React.FC = ()  => {
    return(
        <>  
            <h1>Hello</h1>
        </>
    )
}
export default GetInfo;